//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
    return {
      show: false,
    };
  },
  
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    size: {
      type: String,
      default: 'one',
    },
    excerpt: {
      type: String,
      default: '',
    },
    permalink: {
      type: String,
      default: '#',
    },
    background: {
      default: '', 
    },
  },
  
  computed: {
    styles: function() {
      return {
        'background-image': 'url(' + this.background ? this.background : '' + ')',
      };
    },
  },
  
  watch: {

  },
  
  methods: {
    mouseover: function(){
      this.show = true
    },    
    mouseleave: function(){
      this.show = false
    },
  },
  
  components: {

  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/CallToAction.vue